"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgPlusIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M14.423 1.923C14.423.86 13.563 0 12.5 0s-1.923.86-1.923 1.923v8.654H1.923C.86 10.577 0 11.437 0 12.5s.86 1.923 1.923 1.923h8.654v8.654c0 1.064.86 1.923 1.923 1.923s1.923-.86 1.923-1.923v-8.654h8.654c1.064 0 1.923-.86 1.923-1.923s-.86-1.923-1.923-1.923h-8.654z' }) })));
});
exports.default = (0, react_1.memo)(SvgPlusIcon);
